module.exports = __webpack_public_path__ + "static/media/err404.9ed13bbe.svg";